import { Accordion, AccordionDetails, AccordionSummary, FormControl, FormHelperText, Grid2 } from "@mui/material";
import { ArrowDownward } from "@mui/icons-material";
import MaterialTypography from "../../../../components/MaterialTypography";
import MaterialInput from "../../../../components/MaterialInput";

const ValidationRulesAccordion = ({
  expanded,
  onAccordionChange,
  formData,
  handleChange,
  pageMode,
  accordionSx,
  descriptionSx,
}) => {    
  return (
    <Accordion
      expanded={expanded}
      onChange={(_, isExpanded) => onAccordionChange(isExpanded ? "validationRules" : false)}
      sx={accordionSx}
    >
      <AccordionSummary expandIcon={<ArrowDownward />}>
        <Grid2 container>
          <Grid2 size={{sm: 6, xs: 12 }}>
            <MaterialTypography
              component="span"
              variant="body2"
              fontWeight="bold"
            >
              Validation Rules
            </MaterialTypography>
            <MaterialTypography
              component="div"
              variant="caption"
              sx={descriptionSx}
            >
              Configure input limits and allowed patterns for this field.
            </MaterialTypography>
          </Grid2>
        </Grid2>
      </AccordionSummary>

      <AccordionDetails>
        <Grid2 container spacing={1}>
          {/* minLength */}
          <Grid2 size={{lg:6, md:6, sm: 12, xs: 12 }}>
            <MaterialTypography component="label" variant="caption" fontWeight="bold">
              Minimum Length*
            </MaterialTypography>
            <MaterialInput
              name="minLength"
              placeholder="eg. 1"
              type="number"
              value={formData.minLength}
              onChange={handleChange}
              success={formData.minLengthStatus === "success"}
              error={formData.minLengthStatus === "error"}
              disabled={pageMode === "view"}
            />
            {formData.minLengthStatus === "error" && (
              <FormControl error>
                <FormHelperText>
                  Minimum Length should be a minimum 1 character & maximum 100000 characters long.
                </FormHelperText>
              </FormControl>
            )}
          </Grid2>

          {/* maxLength */}
          <Grid2 size={{lg:6, md:6, sm: 12, xs: 12 }}>
            <MaterialTypography component="label" variant="caption" fontWeight="bold">
              Maximum Length*
            </MaterialTypography>
            <MaterialInput
              name="maxLength"
              placeholder="eg. 1"
              type="number"
              value={formData.maxLength}
              onChange={handleChange}
              success={formData.maxLengthStatus === "success"}
              error={formData.maxLengthStatus === "error"}
              disabled={pageMode === "view"}
            />
            {formData.maxLengthStatus === "error" && (
              <FormControl error>
                <FormHelperText>
                  Maximum Length should be a minimum 1 character & maximum 100000 characters long.
                </FormHelperText>
              </FormControl>
            )}
          </Grid2>

          {/* regex pattern */}
          <Grid2 size={{lg:6, md:6, sm: 12, xs: 12 }}>
            <MaterialTypography component="label" variant="caption" fontWeight="bold">
              Regular Expression Pattern*
            </MaterialTypography>
            <MaterialInput
              name="pattern"
              placeholder="e.g. ^[A-Za-z0-9_]+$"
              value={formData.pattern}
              onChange={handleChange}
              success={formData.patternStatus === "success"}
              error={formData.patternStatus === "error"}
              disabled={pageMode === "view"}
            />
            {formData.patternStatus === "error" && (
              <FormControl error>
                <FormHelperText>
                  Regular Expression Pattern should be a minimum 1 character & maximum 100000 characters long.
                </FormHelperText>
              </FormControl>
            )}
          </Grid2>
        </Grid2>
      </AccordionDetails>
    </Accordion>
  );
};

export default ValidationRulesAccordion;
